module.exports = __webpack_public_path__ + "static/media/cookies.4d3f6f58.svg";